import { WorkOrderJobOpeningStatus } from "@/gql/graphql";
import { Badge, type BadgeColor } from "@/components/catalyst/badge";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "@/components/catalyst/dropdown";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateWorkOrderJobOpeningMutation } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrderJobOpeningMutations";
import { useTranslations } from "use-intl";

const statusColorMap: Record<WorkOrderJobOpeningStatus, BadgeColor> = {
  [WorkOrderJobOpeningStatus.Open]: "green",
  [WorkOrderJobOpeningStatus.Closed]: "zinc",
};

const statuses: WorkOrderJobOpeningStatus[] = [
  WorkOrderJobOpeningStatus.Open,
  WorkOrderJobOpeningStatus.Closed,
];

interface JobOpeningStatusBadgeProps {
  id: string;
  status: WorkOrderJobOpeningStatus;
}

export function JobOpeningStatusBadge({
  id,
  status,
}: JobOpeningStatusBadgeProps) {
  const { mutateAsync } = useGqlMutation(updateWorkOrderJobOpeningMutation);
  const t = useTranslations("workOrder.jobOpenings.jobOpeningStatus");

  return (
    <div>
      <Dropdown>
        <DropdownButton as="button" className="cursor-pointer">
          <Badge color={statusColorMap[status]}>
            {t(status)}
            <ChevronDownIcon className="size-4" />
          </Badge>
        </DropdownButton>
        <DropdownMenu anchor="bottom end">
          {statuses.map((s) => (
            <DropdownItem
              key={s}
              onClick={() => mutateAsync({ id, input: { status: s } })}
              disabled={s === status}
              className="flex items-center justify-end gap-2"
            >
              {s === status ? (
                <CheckIcon className="size-4 text-green-600" />
              ) : (
                <div className="size-4" />
              )}
              <span className="text-sm">{t(s)}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
